import { render, staticRenderFns } from "./SelectOrCustom.vue?vue&type=template&id=94f032e2"
import script from "./SelectOrCustom.vue?vue&type=script&lang=js"
export * from "./SelectOrCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports